<section *ngIf="!viewDetails">
  <div class="p-3 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card rounded mb-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            <p class="card-title">Make Scheme</p>
          </div>
        </div>
        <div class="card-body pt-3 pb-3">
          <!-- Scheme Cards View -->
          <div class="row g-4">
            <div class="col-12 col-md-6 col-lg-3" *ngFor="let scheme of schemes">
              <div class="card scheme-card h-100 p-3">
                <div class="d-flex flex-wrap align-items-center justify-content-between mx-1 my-2">
                  <div class="flex-grow-1 me-2 d-flex justify-content-between">
                    <p-tag severity="danger" [rounded]="true" [value]="scheme.code" />
                  </div>
                </div>

                <!-- Main body -->
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center mb-3">
                    <h5 class="mb-0">{{ scheme.name.toUpperCase() }} SCHEME</h5>
                  </div>

                  <!-- Description with ellipsis and tooltip -->
                  <p class="text-muted-card small mb-3 scheme-description" [pTooltip]="scheme.description"
                    tooltipPosition="top">
                    {{ scheme.description }}
                  </p>

                  <!-- Bottom content wrapped in mt-auto to push it down -->
                  <div class="mt-auto">
                    <button class="btn btn-gradient-light w-100" (click)="selectScheme(scheme)">
                      View Modules <i class="pi pi-arrow-right me-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="p-3 container-fluid" *ngIf="viewDetails">
  <div class="row">
    <div class="col-12">
      <div class="card-body">
        <div class="flex items-center justify-between w-full">
          <div
            class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-500 shadow-sm overflow-x-auto">
            <button *ngFor="let tab of schemeStatusTabs"
              class="flex items-center justify-start gap-2 px-2.5 py-2.5 rounded-xl text-xs font-bold transition-all duration-200 whitespace-nowrap min-w-fit outline-none"
              [ngClass]="activeStatusTabIndex.status === tab.status 
                ? 'bg-slate-800 text-white shadow-md ring-1 ring-slate-300' 
                : 'text-slate-700 hover:text-white hover:bg-slate-600/70'" (click)="onSchemeStatusTabChange(tab)">

              <span class="w-2 h-4 rounded-2xl" [ngClass]="{
                  'bg-gray-600': tab.status === 'form',
                  'bg-blue-700': tab.status === 'initiated',
                  'bg-amber-700': tab.status === 'apso_approve',
                  'bg-emerald-700': tab.status === 'approved',
                  'bg-slate-700': tab.status === 'short_close',
                  'bg-red-700': tab.status === 'rejected'
                }">
              </span>

              {{ tab.label }}
            </button>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content" [class.active]="true">
          <!-- New Scheme Tab - Show Form -->
          <div *ngIf="activeStatusTabIndex.tab === 0" class="card proposal-card mt-3 shadow-sm border-0">
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h5 class="card-title text-white mb-0">Create New Proposal</h5>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-warning px-4 py-2" (click)="saveDraft()">Save Draft</button>
                <button type="button" class="btn btn-success px-4 py-2" (click)="openDialog()"
                  *ngIf="areMandatoryFieldsFilled()"> Submit </button>
              </div>
            </div>
            <div class="card-body">
              <!-- <div *ngIf="draftProposals && draftProposals.length > 0" class="mb-3">
                <div class="alert alert-info" role="alert">
                  <i class="pi pi-info-circle"></i>
                  <span>
                    <b>Draft Proposals Found:</b> Select a draft below to continue editing, or fill in the form to create a new proposal.
                  </span>
                  <div class="table-responsive mt-3">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="table-light">
                        <tr>
                          <th>#</th>
                          <th>Nomenclature</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let draft of draftProposals; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <span class="fw-bold">{{ draft.nomenclature || draft.proposalName }}</span>
                          </td>
                          <td>
                            <span class="badge bg-secondary">
                              Draft Proposal
                            </span>
                          </td>
                          
                          <td>
                            <button class="btn btn-sm btn-outline-primary" type="button" (click)="populateDraftProposal(draft)">
                              Edit This Draft
                            </button>
                          </td>
                         
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> -->
              <div *ngIf="draftProposals && draftProposals.length > 0" class="mb-3">

                <div class="alert alert-info" role="alert">
                  <div class="collapsible-section">
                    <div (click)="isSectionOpen.draftProposals = !isSectionOpen.draftProposals">

                      <i class="pi pi-info-circle me-1"></i>
                      <span>
                        <b>Draft Proposals Found:</b> Select a draft below to continue editing, or fill in the form to
                        create a new proposal.
                      </span>
                      <i class="pi ms-2"
                        [ngClass]="isSectionOpen.draftProposals ? 'pi-chevron-down' : 'pi-chevron-right'"></i>

                    </div>
                    <div class="collapsible-body" *ngIf="isSectionOpen.draftProposals">
                      <app-data-table [data]="draftProposals" [title]="'Draft Proposals'"
                        [url]="'/make1/save-draft/proposal/'" [isEditable]="true" [showAddButton]="false"
                        (editEventRow)="populateDraftProposal($event) ; isSectionOpen.draftProposals =false "
                        [columns]="draftProposalColumns">
                      </app-data-table>
                    </div>
                  </div>
                </div>
              </div>

              <form [formGroup]="proposalForm" class="space-y-4" autocomplete="off">

                <!-- Header Section - Proposal Name and Scheme -->
                <div class="flex flex-col justify-end">
                  <label class="block text-sm font-bold text-blue-900 uppercase tracking-wider mb-3">
                    Is this proposal in reference to a requirement requested by the DOI?
                  </label>

                  <div class="flex items-center gap-6">

                    <!-- YES -->
                    <div class="flex items-center gap-2">
                      <input type="radio" id="seek_proposalYes" name="seek_proposal" formControlName="seek_proposal"
                        [value]="true" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
                      <label for="seek_proposalYes" class="mb-0 text-sm font-medium text-gray-700">
                        Yes
                      </label>
                    </div>

                    <!-- NO (DEFAULT SELECTED) -->
                    <div class="flex items-center gap-2">
                      <input type="radio" id="seek_proposalNo" name="seek_proposal" formControlName="seek_proposal"
                        [value]="false" checked class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
                      <label for="seek_proposalNo" class="mb-0 text-sm font-medium text-gray-700">
                        No
                      </label>
                    </div>

                  </div>
                </div>



                <div
                  class="bg-amber-100/70 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div
                    class="flex items-center justify-between p-4 bg-gray-100/90 text-gray-700 border-b font-medium text-lg">
                    <h3 class="text-lg font-semibold text-slate-800 flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-file"></i>
                      </span>
                      Create New Proposal
                    </h3>
                  </div>
                  <div class="p-6 space-y-4 animate-fade-in">
                    <div class="flex items-center gap-4">
                      <label for="proposalName" class="text-sm font-medium text-slate-700 mb-0" style="width:30%">
                        Proposal Name <span class="text-red-500">*</span>
                      </label>
                      <div style="width:65%">
                        <input pInputText id="proposalName" formControlName="proposalName" autocomplete="off"
                          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                        <div
                          *ngIf="proposalForm.get('proposalName')?.invalid && proposalForm.get('proposalName')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Proposal Name is required
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="scheme" class="text-sm font-medium text-slate-700 mb-0" style="width:30%">
                        Scheme <span class="text-red-500">*</span>
                      </label>
                      <div style="width:65%">
                        <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true"
                          filterBy="name" optionLabel="name" optionValue="id" [readonly]="true" placeholder="Scheme"
                          class="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-500 [&_.p-dropdown]:rounded"></p-dropdown>
                        <div *ngIf="proposalForm.get('scheme')?.invalid && proposalForm.get('scheme')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Scheme selection is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div
                  class="bg-amber-100 border-2 border-gray-300 rounded-lg overflow-hidden transition-all duration-200 hover:shadow-md">

                  <div class="p-4 bg-gray-100/90">

                    <div class="flex flex-col md:flex-row md:items-center gap-3">

                      <!-- Label -->
                      <label for="nomenclature" class="text-sm font-medium text-slate-700 md:w-1/4 whitespace-nowrap">
                        1. Nomenclature <span class="text-red-500">*</span>
                      </label>

                      <!-- Input + Error -->
                      <div class="flex-1">
                        <input pInputText id="nomenclature" formControlName="nomenclature" autocomplete="off" class="w-full px-4 py-2.5 border-2 border-slate-400 rounded-md 
                                            focus:ring-2 focus:ring-blue-500 focus:border-transparent 
                                            transition-all" />

                        <div
                          *ngIf="proposalForm.get('nomenclature')?.invalid && proposalForm.get('nomenclature')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Nomenclature is required
                        </div>
                      </div>

                    </div>

                  </div>
                </div>


                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">

                  <!-- Toggle Header -->
                  <div (click)="toggleSection('nomenclature')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">

                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-lime-100 text-lime-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-info-circle"></i>
                      </span>
                      {{ isMakeIII ? '2. Brief Description' : '2. Brief Description / How Is The Requirement Being Met
                      Presently' }}
                    </h3>

                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.nomenclature ? 'pi-chevron-down' : 'pi-chevron-right'">
                    </i>
                  </div>

                  <!-- Toggle Content -->
                  <div *ngIf="isSectionOpen.nomenclature"
                    class="px-6 pt-4 pb-6 border-t border-slate-200 space-y-6 animate-fade-in">

                    <!-- Editor 1 -->
                    <div class="border border-slate-400 rounded-lg p-4 bg-white">
                      <label for="brief_description" class="block text-base text-blue-600 font-semibold mb-3">

                        {{ isMakeIII ? '2.1 Name of the equipment/system/spare and where fitted' : '2.1 Brief
                        Description With Technical Details'}}
                      </label>

                      <editor [init]="init" id="brief_description" formControlName="brief_description">
                      </editor>
                    </div>

                    <!-- Editor 2 -->
                    <div *ngIf="!isMakeIII" class="border border-slate-400 rounded-lg p-4 bg-white">
                      <label for="requirement_met" class="block text-base text-blue-600 font-semibold mb-3">
                        2.2 How Is The Requirement Being Met Presently
                      </label>

                      <editor [init]="init" id="requirement_met" formControlName="requirement_met">
                      </editor>
                    </div>

                  </div>

                </div>


                <!-- dual use technology section - Make I only -->
                <div *ngIf="!isMakeII && !isMakeIII"
                  class="bg-amber-100 border-2 border-gray-300 rounded-lg overflow-hidden transition-all duration-200 hover:shadow-md">

                  <!-- Header (Not visually toggle style, but functionality kept) -->
                  <div (click)="toggleSection('dualUse')" class="p-4 bg-gray-100/90">

                    <div class="flex flex-col md:flex-row md:items-center gap-3">

                      <!-- Label -->
                      <label class="text-sm font-medium text-slate-700 md:w-1/4 whitespace-nowrap">
                        3. Dual Use Technology
                      </label>

                      <!-- Yes / No -->
                      <div class="flex-1 flex items-center gap-8">

                        <div class="flex items-center gap-2">
                          <p-checkbox [binary]="true" inputId="dual_technology"
                            [ngModel]="proposalForm.get('dual_technology')?.value === true"
                            (onChange)="onDualUseTechnologyChange(true)"
                            [ngModelOptions]="{standalone: true}"></p-checkbox>
                          <label for="dual_technology" class="cursor-pointer mb-0">Yes</label>
                        </div>

                        <div class="flex items-center gap-2">

                          <p-checkbox [binary]="true" inputId="dual_technology"
                            [ngModel]="proposalForm.get('dual_technology')?.value === false"
                            (onChange)="onDualUseTechnologyChange(false)"
                            [ngModelOptions]="{standalone: true}"></p-checkbox>
                          <label for="dual_technology" class="cursor-pointer mb-0">No</label>
                        </div>

                      </div>

                    </div>

                  </div>



                </div>


                <!-- Quantity Details Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('quantity')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-sliders-h"></i>
                      </span>
                      {{ (isMakeII || isMakeIII) ? '3' : '4' }}. Quantity Required
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.quantity ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.quantity"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">

                    <div class="flex items-center gap-4">
                      <label for="qtyPrototype" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        {{ (isMakeII || isMakeIII) ? '3.1' : '4.1' }} Quantity Prototype (based on acceptance criteria
                        and tests) <span class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="qtyPrototype" formControlName="qtyPrototype"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-4 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                        <div
                          *ngIf="proposalForm.get('qtyPrototype')?.invalid && proposalForm.get('qtyPrototype')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Quantity Prototype is required
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="qtyBulk" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        {{ (isMakeII || isMakeIII) ? '3.2' : '4.2' }} Quantity Bulk (MOQ) <span
                          class="text-red-500">*</span>
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="qtyBulk" formControlName="qtyBulk" (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-4 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                        <div *ngIf="proposalForm.get('qtyBulk')?.invalid && proposalForm.get('qtyBulk')?.touched"
                          class="text-red-500 text-xs mt-1">
                          Quantity Bulk (MOQ) is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Cost Details Section -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('cost')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-pink-100 text-pink-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-dollar"></i>
                      </span>
                      {{ (isMakeII || isMakeIII) ? '4' : '5' }}. Estimated Cost
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.cost ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.cost"
                    class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">
                    <div class="flex items-center gap-4">
                      <label for="estimatedDevelopmentCost" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        {{ (isMakeII || isMakeIII) ? '4.1' : '5.1' }}. For Development Of Prototype(in INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="estimatedDevelopmentCost" formControlName="estimatedDevelopmentCost"
                          autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>
                    <div class="flex items-center gap-4">
                      <label for="estimatedUnitCost" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                        {{ (isMakeII || isMakeIII) ? '4.2' : '5.2' }}. Unit Cost For Bulk Quantity(in INR)
                      </label>
                      <div class="w-3/4">
                        <input pInputText id="estimatedUnitCost" formControlName="estimatedUnitCost" autocomplete="off"
                          (keypress)="allowOnlyNumbers($event)"
                          class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                      </div>
                    </div>


                    <div
                      class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                      <div (click)="toggleSection('estimatedCost')"
                        class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                        <h3 class="text-lg font-semibold flex items-center">
                          <span
                            class="w-8 h-8 rounded-lg bg-pink-100 text-pink-600 flex items-center justify-center mr-3 text-sm">
                            <i class="pi pi-dollar"></i>
                          </span>
                          {{ (isMakeII || isMakeIII) ? '4.3' : '5.3' }}. Basis of Estimated Cost
                        </h3>
                        <i class="pi transition-transform duration-200"
                          [ngClass]="isSectionOpen.estimatedCost ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                      </div>
                      <div *ngIf="isSectionOpen.estimatedCost"
                        class="px-6 pt-4 pb-6 border-t border-slate-100 animate-fade-in space-y-4">


                        <!-- Make I: show detailed sub-items 5.3.1-5.3.4 -->
                        <ng-container *ngIf="!isMakeII && !isMakeIII">
                          <div class="flex items-center gap-4">
                            <label for="llp" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                              5.3.1 Last Purchase Price(in INR)
                            </label>
                            <div class="w-3/4">
                              <input pInputText id="llp" formControlName="llp" autocomplete="off"
                                (keypress)="allowOnlyNumbers($event)"
                                class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                            </div>
                          </div>
                          <div class="flex items-center gap-4">
                            <label for="lpyear" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                              5.3.2 Last Purchase Year
                            </label>
                            <div class="w-3/4">
                              <p-calendar formControlName="lpyear" view="year" dateFormat="yy"
                                class="w-full [&_.p-calendar]:w-full [&_.p-calendar]:border-slate-500 [&_.p-calendar]:rounded"></p-calendar>
                            </div>
                          </div>
                          <div class="flex items-center gap-4">
                            <label for="exchequer" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                              5.3.3 In Case Similar Development Of The Product Has Been Undertaken Then savings To
                              exchequer
                            </label>
                            <div class="w-3/4">
                              <input pInputText id="exchequer" formControlName="exchequer" autocomplete="off"
                                (keypress)="allowOnlyNumbers($event)"
                                class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                            </div>
                          </div>
                          <div class="flex items-center gap-4">
                            <label for="poev" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                              5.3.4 POEV
                            </label>
                            <div class="w-3/4">
                              <input pInputText id="poev" formControlName="poev" autocomplete="off"
                                (keypress)="allowOnlyNumbers($event)"
                                class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                            </div>
                          </div>
                        </ng-container>

                        <!-- Make II / Make III: simple LPP/similar development field -->
                        <div *ngIf="isMakeII || isMakeIII" class="flex items-center gap-4">
                          <label for="llp" class="text-sm font-medium text-slate-700 mb-0 w-1/4">
                            LPP / Similar Development
                          </label>
                          <div class="w-3/4">
                            <input pInputText id="llp" formControlName="llp" autocomplete="off"
                              (keypress)="allowOnlyNumbers($event)"
                              class="w-full px-2 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

                <!-- Justification to progress the case -->
                <div
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('justification')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-align-left"></i>
                      </span>
                      {{ isMakeIII ? '5' : (isMakeII ? '5' : '6') }}. {{ isMakeIII ? 'Justification for progressing the
                      case under Make-III category' : ('Justification To Progress The Case Under ' + (isMakeII ? 'Make
                      II' : 'Make I') + ' Category') }}
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.justification ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.justification"
                    class="p-6 border-t border-slate-100 animate-fade-in space-y-6">
                    <div class="border border-slate-500 rounded-lg">
                      <label class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        {{ isMakeIII ? '(5.1) Item already held in Inventory requiring Import substitution' : ((isMakeII
                        ?
                        '5.1' : '6.1') + ' Advantage of availability of technology indigenously designed product') }}
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="indigenously_designed" formControlName="indigenously_designed">
                        </editor>
                      </div>
                    </div>
                    <!-- Make I only: 6.2 and 6.3 / Make III: (b) and (c) -->
                    <div *ngIf="!isMakeII" class="border border-slate-500 rounded-lg">
                      <label for="justification_availability" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        {{ isMakeIII ? '(5.2) Cost effectiveness' : '6.2 Avaialability of design capability and
                        infrastructure in India.' }}
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="capability_infrastructure"
                          formControlName="capability_infrastructure"></editor>
                      </div>
                    </div>
                    <div *ngIf="!isMakeII" class="border border-slate-500 rounded-lg">
                      <label for="justification_ltpp" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        {{ isMakeIII ? '(5.3) Lead time' : '6.3 Is the proposed system a part of Long Term Perspective
                        Plan(LTPP)' }}
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="ltpp" formControlName="ltpp"></editor>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Hide standalone lead time for Make III (included as justification sub-item 5c) -->
                <div *ngIf="!isMakeIII" class="border border-slate-400 rounded-lg bg-[#FEF3C7] p-4 shadow-sm">

                  <!-- Label -->
                  <label for="lead_development"
                    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                    {{ isMakeII ? '6' : '7' }}. Expected Lead Time for Prototype Development
                  </label>

                  <!-- Editor -->
                  <editor [init]="init" id="lead_development" formControlName="lead_development">
                  </editor>

                </div>

                <div class="space-y-8">

                  <!-- 8 -->
                  <div
                    class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">

                    <!-- Toggle Header -->
                    <div (click)="toggleSection('requirementIndigenise')"
                      class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">

                      <h3 class="text-lg font-semibold flex items-center">
                        <span
                          class="w-8 h-8 rounded-lg bg-lime-100 text-lime-600 flex items-center justify-center mr-3 text-sm">
                          <i class="pi pi-info-circle"></i>
                        </span>
                        {{ isMakeIII ? '6. Vintage and OEM' : ((isMakeII ? '7' : '8') + '. Requirement to indigenise the
                        proposed equipment (Details of vintage and OEM)') }}
                      </h3>

                      <i class="pi transition-transform duration-200"
                        [ngClass]="isSectionOpen.requirementIndigenise ? 'pi-chevron-down' : 'pi-chevron-right'">
                      </i>
                    </div>

                    <!-- Toggle Content -->
                    <div *ngIf="isSectionOpen.requirementIndigenise"
                      class="px-6 pt-4 pb-6 border-t border-slate-200 space-y-6 animate-fade-in">

                      <!-- Editor for 6. Vintage and OEM (Make III only) -->
                      <div *ngIf="isMakeIII" class="border border-slate-400 rounded-lg p-4 bg-white">
                        <editor [init]="init" id="vinatge_oem" formControlName="vinatge_oem">
                        </editor>
                      </div>

                      <!-- Editor 1 -->
                      <div class="border border-slate-400 rounded-lg p-4 bg-white">
                        <label for="indigenise_equipment" class="block text-base text-blue-600 font-semibold mb-3">
                          {{ isMakeIII ? '7. Requirement of indigenizing existing equipment view obsolescence or
                          upgradation or replacement' : ((isMakeII ? '7.1' : '8.1') + ' In view of obsolescence/
                          upgradtion/ replacement/ import substitution / new induction to counter emerging threat
                          perception') }}
                        </label>

                        <editor [init]="init" id="indigenise_equipment" formControlName="indigenise_equipment">
                        </editor>
                      </div>


                    </div>

                  </div>


                  <!-- 9 / 8 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '8' : (isMakeII ? '8' : '9') }}. {{ isMakeIII ? 'Details of RFI undertaken with
                      date for the same and responses therein' : ('Details of RFI/Market survey undertaken with date and
                      responses therein / whether indigenous capability exists (List of prospective firms)' + (isMakeII
                      ? ' / Details of any collaboration with foreign OEM envisaged' : '')) }}
                    </label>
                    <editor [init]="init" id="rfi_indigenous" formControlName="rfi_indigenous">
                    </editor>
                  </div>

                  <div *ngIf="isMakeIII"
                    class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">

                    <!-- Accordion Header -->
                    <div (click)="toggleSection('manufacture')"
                      class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">

                      <h3 class="text-lg font-semibold flex items-center">
                        <span
                          class="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3 text-sm">
                          <i class="pi pi-align-left"></i>
                        </span>

                        9. Proposed to manufacture in India through which firms (with details)/franchises of OEM/Details
                        of market survey undertaken
                      </h3>

                      <i class="pi transition-transform duration-200"
                        [ngClass]="isSectionOpen.manufacture ? 'pi-chevron-down' : 'pi-chevron-right'">
                      </i>
                    </div>

                    <!-- Accordion Content -->
                    <div *ngIf="isSectionOpen.manufacture"
                      class="p-6 border-t border-slate-100 animate-fade-in space-y-6">

                      <div class="border border-slate-500 rounded-lg">
                        <label class="text-base p-2 text-blue-600 font-semibold mb-0">
                          9.1 Confirmation from at least one known MSME or vendor that the equipment/system can be
                          developed and manufactured in India as per design of OEM with minimum 60% Indigenous Content
                        </label>

                        <editor [init]="init" id="collaboration_envisaged" formControlName="collaboration_envisaged">
                        </editor>
                      </div>

                    </div>

                  </div>



                  <!-- 10 - Make I / Make III -->
                  <div *ngIf="!isMakeII && !isMakeIII"
                    class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

                      10. Details of any collaboration envisaged with foreign
                      partner (If yes, details to be provided)

                    </label>
                    <editor [init]="init" id="collaboration_envisaged" formControlName="collaboration_envisaged">
                    </editor>
                  </div>

                  <!-- 11 / 10 / 9 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '10' : (isMakeII ? '9' : '11') }}.
                      {{
                      isMakeIII
                      ? 'Confirmation of at least one Indian Entity/Firm ready to undertake JV/ToT with the Foreign OEM'
                      : (isMakeII
                      ? 'Confirmation that indigenisation is not being undertaken through DRDO/PSU'
                      : 'Confirmation that indigenisation is not being undertaken through DRDO/PSU or IA/IAF (If
                      indigenisation has been attempted previously, then the bottleneck that the present proposal aims
                      to overcome)')
                      }}
                    </label>
                    <editor [init]="init" id="drdo_psu" formControlName="drdo_psu">
                    </editor>
                  </div>

                  <!-- 12 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '11' : (isMakeII ? '10' : '12') }}.
                      {{ isMakeIII ? 'Details of technical specifications of the equipment/ system/ spare' : (isMakeII ?
                      'Details of technical specifications of the equipment/system / Role of the proposed item/ system
                      in overall operational strategy' : 'Details of technical specifications of the equipment/system')
                      }}
                    </label>
                    <editor [init]="init" id="technical_specifications" formControlName="technical_specifications">
                    </editor>
                  </div>

                  <!-- 13 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '12' : (isMakeII ? '11' : '13') }}.
                      {{ isMakeIII ? 'Details of operational requirements of the equipment/system/spare' : (isMakeII ?
                      'Details of
                      operational requirements of the equipment' : 'Details of operational requirements of the equipment
                      / Role of proposed item in overall operation strategy') }}
                    </label>
                    <editor [init]="init" id="operational_requirement" formControlName="operational_requirement">
                    </editor>
                  </div>

                  <!-- 14 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '13' : (isMakeII ? '12' : '14') }}. Availability of drawings/manuals/technical
                      documentation
                    </label>
                    <editor [init]="init" id="drawings_manuals" formControlName="drawings_manuals">
                    </editor>
                  </div>

                  <!-- 15 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '14' : (isMakeII ? '13' : '15') }}. Availability of sample for indigenisation (if
                      required)
                    </label>
                    <editor [init]="init" id="sample_indigenisation" formControlName="sample_indigenisation">
                    </editor>
                  </div>

                  <!-- 16 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '15' : (isMakeII ? '14' : '16') }}.
                      {{isMakeIII ? 'Confirmation if project is included in Annual Acquisition Plan' : 'Confirmation if
                      project is included in Annual
                      Acquisition Plan /
                      Long Term Perspective Plan' }}

                    </label>
                    <editor [init]="init" id="annual_Acquisition" formControlName="annual_Acquisition">
                    </editor>
                  </div>

                  <!-- 17 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '16' : (isMakeII ? '15' : '17') }}. List and venue of likely trials and
                      environmental tests /
                      Type IAW MIL or other standards
                    </label>
                    <editor [init]="init" id="trials_environments" formControlName="trials_environments">
                    </editor>
                  </div>

                  <!-- 18 -->
                  <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      {{ isMakeIII ? '17' : (isMakeII ? '16' : '18') }}. Availability of photograph of item
                    </label>
                    <editor [init]="init" id="photograph_item" formControlName="photograph_item">
                    </editor>
                  </div>

                  <!-- 19 - Make I only (hidden for Make II and Make III) -->
                  <div *ngIf="!isMakeII && !isMakeIII"
                    class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      19. Any envisaged export potential of the equipment/system
                      (For viability of the proposal to be taken under Make I category)
                    </label>
                    <editor [init]="init" id="export_potential" formControlName="export_potential">
                    </editor>
                  </div>




                </div>


                <!-- Draft reports - Make I only (hidden for Make II and Make III) -->
                <div *ngIf="!isMakeII && !isMakeIII"
                  class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('reports')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-align-left"></i>
                      </span>
                      20. Draft Project Report/Feasibility Report
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.reports ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.reports" class="p-6 border-t border-slate-100 animate-fade-in space-y-6">
                    <div class="border border-slate-500 rounded-lg">
                      <label class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        20.1 Description of critical technology required
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="critical_technology" formControlName="critical_technology"></editor>
                      </div>
                    </div>
                    <div class="border border-slate-500 rounded-lg">
                      <label for="detailed_justification" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        20.2 Infrastructure required/Available with DRDO/Services/PSU
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="drdo_infrastructure" formControlName="drdo_infrastructure"></editor>
                      </div>
                    </div>
                    <div class="border border-slate-500 rounded-lg">
                      <label for="detailed_exportPotential" class="text-base p-2 text-blue-600 font-semibold mb-0 ">
                        20.3 Infrastructure required for trials
                      </label>
                      <div class=" ">
                        <editor [init]="init" id="trial_infrastructure" formControlName="trial_infrastructure"></editor>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                  <label
                    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                    {{ isMakeIII ? '18' : (isMakeII ? '17' : '21') }}.
                    {{ isMakeIII ? 'Confirmation that the indigenization is not being undertaken through DRDO/PSU' :
                    'Details of projects similar projects being
                    undertaken by IA/IAF/DRDO
                    or through
                    Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any
                    similar system already existing in the inventory.'}}

                  </label>
                  <editor [init]="init" id="project_similar" formControlName="project_similar">
                  </editor>
                </div>


                <!-- Make I order: APSO (22) then Nodal Officer (23) / hidden for Make III -->
                <ng-container *ngIf="!isMakeII">
                  <div *ngIf="!isMakeIII" class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      22. Approval and priority from APSO concerned for case under Make I category
                    </label>
                    <editor [init]="init" id="approval_apso" formControlName="approval_apso">
                    </editor>
                  </div>

                  <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

                      {{ isMakeIII ? '19. Details of nodal officer execute the project through the Capital Route under
                      MAKE III category
                      from user Dte.' : '23. Details of nodal officer execute the project through the Capital Route
                      under MAKE I category
                      from user Dte.' }}
                    </label>
                    <editor [init]="init" id="detailed_nodalOfficerDetails" formControlName="nodalOfficerDetails">
                    </editor>
                  </div>

                  <div *ngIf="isMakeIII" class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      20. Approval and priority from APSO concerned for each of the cases to be fielded under Make III
                      category
                    </label>
                    <editor [init]="init" id="approval_apso" formControlName="approval_apso">
                    </editor>
                  </div>
                </ng-container>

                <!-- Make II order: Nodal Officer (18) then APSO (19) -->
                <ng-container *ngIf="isMakeII">
                  <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      18. Details of nodal officer execute the project through the Capital Route under MAKE II category
                      from user Dte.
                    </label>
                    <editor [init]="init" id="detailed_nodalOfficerDetails_make2" formControlName="nodalOfficerDetails">
                    </editor>
                  </div>

                  <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                    <label
                      class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                      19. Approval and priority from APSO concerned for case under Make II category
                    </label>
                    <editor [init]="init" id="approval_apso_make2" formControlName="approval_apso">
                    </editor>
                  </div>
                </ng-container>

                <!-- 20 - Make II only: Revenue/iDEX procurement -->
                <div *ngIf="isMakeII" class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5">
                  <label
                    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
                    20. Is Item under Revenue/iDEX procurement?
                  </label>
                  <editor [init]="init" id="revenue_idex" formControlName="revenue_idex">
                  </editor>
                </div>

                <!-- Document Uploads Section -->
                <div
                  class="bg-amber-100  border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg">
                  <div (click)="toggleSection('uploads')"
                    class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                    <h3 class="text-lg font-semibold flex items-center">
                      <span
                        class="w-8 h-8 rounded-lg bg-cyan-100 text-cyan-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-upload"></i>
                      </span>
                      Document Uploads
                    </h3>
                    <i class="pi transition-transform duration-200"
                      [ngClass]="isSectionOpen.uploads ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  </div>
                  <div *ngIf="isSectionOpen.uploads" class="p-6 border-t border-slate-100 animate-fade-in">
                    <app-upload-document [isEditable]="true" [dmsFiles]="selectedDraftProposal?.dms_files||[]"
                      [isSaveVied]="true" (uploadData)="onDocumentUpload($event)">
                    </app-upload-document>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Status Tabs Content - Show Proposals Table -->
          <div *ngIf="activeStatusTabIndex.tab !== 0" class="card mt-3 shadow-sm border-0">
            <div class="card-header bg-primary text-white">
              <h5 class="card-title text-white mb-0">{{ activeStatusTabIndex.label }}</h5>
            </div>
            <div class="card-body">

              <div class="table-responsive p-3">
                <p-table #dt [value]="proposalData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[5, 10, 20, 50]" [paginator]="true" [lazy]="lazy" [totalRecords]="totalCount"
                  (onPage)="onPageChange($event)"
                  [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
                  [scrollable]="true" [(selection)]="selectedProposals" scrollDirection="both" [resizableColumns]="true"
                  [reorderableColumns]="true"
                  [globalFilterFields]="['name','description','proposal_status','created_by.first_name','created_by.last_name']"
                  dataKey="id" class="p-datatable-sm complex-proposal-table">

                  <ng-template pTemplate="header">
                    <tr>
                      <ng-container *ngFor="let column of tableColumns">
                        <th (click)="lazy=false" [pSortableColumn]=" column.field" pResizableColumn
                          class="sortable-column">
                          <!-- Column Header -->
                          <ng-container [ngSwitch]="column.field">
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                              <!-- <p-sortIcon styleClass="custom-sort-icon mx-2 text-white bg-amber-100" [field]="column.field"></p-sortIcon> -->
                              <span>{{ column.header }}</span>
                            </ng-container>
                          </ng-container>

                          <!-- Column Filter -->
                          <p-columnFilter class="text-gray-600" *ngIf="column.filter" [type]="column.filterType"
                            [field]="column.field" display="menu" [showMatchModes]="true" [showOperator]="false"
                            [showAddButton]="false"></p-columnFilter>
                        </th>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 🧩 Table Body -->
                  <ng-template pTemplate="body" let-proposal>
                    <tr [ngClass]="{ 'table-row-hover': true }">
                      <ng-container *ngFor="let column of tableColumns">
                        <td class="align-middle text-nowrap">
                          <ng-container [ngSwitch]="column.field">

                            <!-- ✅ Checkbox -->
                            <ng-container *ngSwitchCase="'checkbox'">
                              <p-tableCheckbox [value]="proposal" selectionMode="multiple"></p-tableCheckbox>
                            </ng-container>

                            <!-- ✅ Name -->
                            <ng-container *ngSwitchCase="'name'">
                              <span class="fw-semibold text-primary pointer" pTooltip="{{ proposal.name }}"
                                (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                {{ proposal.name }}
                              </span>
                            </ng-container>

                            <!-- ✅ Description -->
                            <ng-container *ngSwitchCase="'description'">
                              <span class="text-muted text-truncate d-inline-block" style="max-width: 250px;"
                                [pTooltip]="proposal.description">
                                {{ proposal.description }}
                              </span>
                            </ng-container>

                            <!-- ✅ Steps -->
                            <ng-container *ngSwitchCase="'steps'">
                              <span class="badge bg-info text-dark">
                                {{ proposal.step_summary?.completed_steps || 0 }}/{{ proposal.step_summary?.total_steps
                                || 0 }}
                              </span>
                            </ng-container>

                            <!-- ✅ Progress -->
                            <ng-container *ngSwitchCase="'progress'">
                              <div class="progress" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                  [style.width.%]="proposal.step_summary?.completed_percentage || 0"></div>
                              </div>
                              <small class="text-muted">
                                {{ proposal.step_summary?.completed_percentage || 0 }}%
                              </small>
                            </ng-container>

                            <!-- ✅ Created By -->
                            <ng-container *ngSwitchCase="'created_by'">
                              <i class="pi pi-user text-secondary me-1"></i>
                              {{ proposal.created_by?.first_name }} {{ proposal.created_by?.last_name }}
                            </ng-container>

                            <!-- ✅ Directorate -->
                            <ng-container *ngSwitchCase="'directorate'">
                              <i class="pi pi-building text-secondary me-1"></i>
                              {{ proposal.created_by?.unit?.name }}
                            </ng-container>

                            <!-- ✅ Status -->
                            <ng-container *ngSwitchCase="'proposal_status'">
                              <span class="badge rounded-pill px-3 py-1"
                                [ngClass]="getStatusBadgeClass(proposal.proposal_status)">
                                {{ proposal.proposal_status | titlecase }}
                              </span>
                            </ng-container>

                            <!-- ✅ Actions -->
                            <ng-container *ngSwitchCase="'actions'">
                              <button pButton type="button" icon="pi pi-ellipsis-v"
                                class="p-button-rounded p-button-text action-btn" (click)="op.toggle($event)"></button>

                              <p-overlayPanel #op>
                                <div class="list-group small">
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="updateProposal(proposal)">
                                    Edit
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer text-danger"
                                    (click)="deleteProposal(proposal)">
                                    Delete
                                  </a>
                                  <a class="list-group-item list-group-item-action pointer"
                                    (click)="navigateToSchemeTransaction(proposal, activePhaseId)">
                                    Go to Steps
                                  </a>
                                </div>
                              </p-overlayPanel>
                            </ng-container>

                            <!-- ✅ Default -->
                            <ng-container *ngSwitchDefault>
                              {{ getFieldValue(proposal, column.field) || '-' }}
                            </ng-container>

                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-template>

                  <!-- 📉 Empty Message -->
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="tableColumns.length" class="text-center text-muted py-3">
                        <i class="pi pi-info-circle me-2"></i> No proposals found.
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #proposalCardTemplate let-proposal>
  <div class="card scheme-card h-100 p-3">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
      <p-tag severity="info" [value]="proposal?.scheme?.name" class="mb-2 mb-sm-0"></p-tag>
      <div class="d-flex gap-3">
        <span (click)="deleteProposal(proposal)" class="btn btn-light" pTooltip="Delete Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Delete') ||
            proposal.can_edit == true
          "><i class="pi pi-trash delete-red"></i></span>
        <span (click)="updateProposal(proposal)" class="btn btn-light" pTooltip="Edit Proposal" tooltipPosition="top"
          *ngIf="
            ('/master/proposal' | hasPermission : 'Edit') ||
            proposal.can_edit == true
          "><i class="pi pi-pencil"></i></span>
        <span (click)="navigateToSchemeTransaction(proposal, activePhaseId)" class="btn btn-light"
          pTooltip="Go to Steps" tooltipPosition="top" *ngIf="'/master/proposal' | hasPermission : 'View'"><i
            class="pi pi-arrow-right"></i></span>
      </div>
    </div>

    <div class="ms-1">
      <h5 class="fw-bold mb-1">{{ proposal?.name }}</h5>
      <p class="text-muted-card small mb-3 description-truncate" [pTooltip]="proposal.description"
        tooltipPosition="top">
        {{ proposal.description }}
      </p>
    </div>

    <div class="mt-auto">
      <div class="d-flex justify-content-between small text-muted-card ms-1 mb-1">
        <span>Step {{ proposal.step_summary.completed_steps || 0 }}/{{
          proposal.step_summary.total_steps || 0
          }}</span>
        <span>{{ proposal.step_summary.completed_percentage }}% Complete</span>
      </div>
      <div class="progress ms-1 mb-3">
        <div class="progress-bar bg-primary" role="progressbar"
          [style.width.%]="proposal.step_summary.completed_percentage" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="text-muted-card small">
          <i class="bi bi-clock me-1"></i> Created
          {{ proposal.created_on | date : "dd-MM-yyyy" }}
        </div>
        <p-tag [value]="proposal.proposal_status | uppercase" severity="success" rounded></p-tag>
      </div>

      <button class="btn btn-gradient w-100" (click)="navigateToScheme(proposal)">
        View Details
      </button>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isDeleteProposal">
  <p-dialog header="Delete Proposal" [modal]="true" [(visible)]="isDeleteProposal" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog">
      <span>Are you sure , you want to delete
        {{ selectedProposal.name }} proposal?</span>
      <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()">
      </p-button>
    </div>
  </p-dialog>
</ng-container>


<ng-container *ngIf="addProposalVisible">
  <p-dialog [maximizable]="true" [header]="getDialogHeader()" [modal]="true" [(visible)]="addProposalVisible"
    [style]="{ width: '70rem' }">
    <div class="mt-3">
      <div class="custom-stepper">
        <div *ngFor="let item of items; let i = index" class="step-item" [class.active]="i === activeIndex"
          (click)="setActiveIndex(i)">
          <div class="step-number">{{ i + 1 }}</div>
          <div class="step-label">{{ item.label }}</div>
          <div class="step-connector" *ngIf="i < items.length - 1"></div>
        </div>
      </div>

      <div class="mt-4 mb-4">
        <!-- Step 1 Content -->
        <div *ngIf="items[activeIndex]?.label === 'Add Proposal'">
          <form [formGroup]="proposalForm" class="mt-1">
            <div class="row">
              <div class="col-md-6">
                <label for="proposalName">Proposal Name <b class="text-danger">*</b></label>
                <input pInputText id="proposalName" pSize="large" formControlName="proposalName" autocomplete="off"
                  class="w-100" />
                <div *ngIf="
                    proposalForm.get('proposalName')?.invalid &&
                    proposalForm.get('proposalName')?.touched
                  " class="text-danger mb-3">
                  Proposal Name is required
                </div>
              </div>
              <div class="col-md-6">
                <label class="ps-2" for="scheme">Scheme <b class="text-danger">*</b></label>
                <p-dropdown inputId="scheme" formControlName="scheme" [options]="schemes" [filter]="true"
                  filterBy="name" optionLabel="name" placeholder="Scheme" [style]="{ width: '100%' }" [disabled]="true"
                  optionValue="id">
                </p-dropdown>
                <div *ngIf="
                    proposalForm.get('scheme')?.invalid &&
                    proposalForm.get('scheme')?.touched
                  " class="text-danger mb-3">
                  Scheme selection is required
                </div>
              </div>
            </div>
            <div class="mb-4 ms-1 px-1 w-100 pt-3">
              <label for="over_label">Proposal Description <b class="text-danger">*</b></label>
              <textarea pInputTextarea id="over_label" rows="5" pSize="large" formControlName="description"
                autocomplete="off" class="w-100" maxlength="250"></textarea>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" (click)="onSubmit()" class="btn btn-primary"
                [disabled]="proposalForm.invalid || proposalForm.pristine">
                Submit
              </button>
            </div>
          </form>
        </div>
        <!-- Award of Contract -->
        <!-- Step 2: Mandatory steps from previous phases -->
        <div *ngIf="
            items[activeIndex]?.label === 'Mandatory steps from Previous Phases'
          ">
          <div class="card p-3">
            <div class="d-flex justify-content-between mb-3">
              <h5 class="mb-3">Mandatory Steps from Previous Phases</h5>
              <div class="d-flex justify-content-end">
                <button type="button" (click)="
                    navigateToSchemeTransaction(selectedProposal, phases[0].id)
                  " class="btn btn-primary">
                  Fill Details
                </button>
              </div>
            </div>

            <ng-container *ngFor="let phase of transactionPhaseStages">
              <div class="border p-3 mb-4">
                <h6 class="mb-3">
                  <b>{{ phase.phase.name }}</b>
                </h6>

                <ng-container *ngFor="let stage of phase.stages; let i = index">
                  <!-- Only show non-skipped (mandatory) steps -->
                  <ng-container *ngIf="!stage.skipped">
                    <div class="row align-items-center mb-3">
                      <div class="col-auto">
                        <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i"
                          name="targetStage" [checked]="true" [disabled]="true" />
                      </div>
                      <div class="col">
                        <label class="form-check-label" [for]="'stage' + i">
                          <div class="d-flex flex-column">
                            <span class="fw-medium">{{ stage.name }}</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
            <div class="d-flex justify-content-end">
              <button type="button" (click)="next()" class="btn btn-primary">
                Proceed
              </button>
            </div>
          </div>
        </div>

        <!-- Step 2 Content -->
        <div *ngIf="
            items[activeIndex]?.label === 'Skip Stages' &&
            currentUserRoleId == '6'
          ">
          <div class="card p-3 mt-4 skip-stage-container">
            <!-- Important Notice -->
            <div class="alert alert-warning mb-4">
              <i class="bi bi-exclamation-circle me-2"></i>
              <strong>Important</strong>
              <p class="mb-0 mt-1">
                Select steps to skip or proceed with all the steps shown below.
                Skipping steps will remove those from the Proposal. This action
                cannot be undone.
              </p>
            </div>

            <!-- Stage Selection -->
            <div class="mb-4">
              <div class="d-flex justify-content-between">
                <h6 class="mb-3">Select Target Step</h6>
                <h6 class="mb-3">
                  <span class="badge bg-primary px-3 py-2 fs-6">
                    Allocated: {{ completionSum || 0 }}%
                  </span>
                </h6>
              </div>
              <div class="stages-list">
                <div class="form-check mb-3" *ngFor="let stage of stages; let i = index">
                  <input class="form-check-input border-primary" type="checkbox" [id]="'stage' + i" name="targetStage"
                    [value]="stage.id" [(ngModel)]="stage.skipped" [disabled]="stage.id <= currentStage" />
                  <label class="form-check-label w-100" [for]="'stage' + i">
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="d-flex flex-column">
                        <span class="fw-medium">
                          {{ stage.name }} -
                          <p-tag [value]="'step - ' + stage.sequence" severity="secondary" rounded></p-tag>
                        </span>
                        <small class="text-muted-card">{{
                          stage.description
                          }}</small>
                      </div>

                      <div class="d-flex align-items-end gap-3" *ngIf="!stage.skipped">
                        <!-- Timeline Input -->
                        <div class="">
                          <label class="form-label mb-1 small text-muted">Timeline (weeks)</label>
                          <input type="number" class="form-control form-control-sm w-100px" min="1"
                            [(ngModel)]="stage.week_timeline" placeholder="e.g. 2" />
                        </div>

                        <!-- Completion % Input -->
                        <div class="w-120px">
                          <label class="form-label mb-1 small text-muted">Completion %</label>
                          <input type="number" class="form-control form-control-sm w-120px" min="0" max="100"
                            [(ngModel)]="stage.percentage" (ngModelChange)="onCompletionChange()"
                            placeholder="e.g. 20" />
                        </div>
                      </div>
                    </div>
                  </label>

                  <!-- Textarea for skipped reason -->
                  <div *ngIf="stage.skipped" class="mt-2">
                    <textarea class="form-control" rows="3" placeholder="Enter reason for skipping this stage..."
                      [(ngModel)]="stage.remark"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="completionSum > 100" class="text-danger mt-2">
              Total completion percentage cannot exceed 100%.
            </div>

            <div *ngIf="
                anyCompletionEntered && !allCompletionFilled && !canSubmit()
              " class="text-danger mt-2">
              Please fill all Completion % fields if entering any.
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end gap-2">
              <button class="btn btn-light" (click)="addProposalVisible = false">
                Cancel
              </button>
              <button class="btn btn-primary" (click)="confirmSkipStage(); next()" [disabled]="
                  !canSubmit() ||
                  completionSum != 100 ||
                  (anyCompletionEntered && !allCompletionFilled)
                ">
                <i class="bi bi-skip-forward me-1"></i>
                Proceed
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="items[activeIndex]?.label === 'Route Configuration'">
          <div class="p-3 mt-4">
            <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Steps</label>
                  <p-dropdown [options]="filteredStagesList" formControlName="step" optionValue="id" optionLabel="name"
                    placeholder="Select a Step" class="w-100" (onChange)="onStepChange($event)" [filter]="true"
                    filterBy="name">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3" *ngIf="!this.routeForm.get('approved')?.value">
                  <label>Role</label>
                  <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
                    placeholder="Select a Role" class="w-100" (onChange)="onRoleChange($event)" [filter]="true"
                    filterBy="name">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Directorate</label>
                  <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
                    placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
                    filterBy="name" appendTo="body">
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3">
                  <label>User</label>
                  <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="first_name"
                    placeholder="Select a User" class="w-100" (onChange)="onUserChange($event)" [filter]="true"
                    filterBy="first_name" appendTo="body">
                    <ng-template let-user pTemplate="item">
                      <div class="list-group-item list-group-item-action">
                        {{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - <small>{{ user.loginname
                          }}</small>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <div class="col-md-6 mb-3 flex-col" *ngIf="!this.routeForm.get('approved')?.value">
                  <label for="menuIcon">Sequence</label>
                  <input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
                    class="w-100" [disabled]="true" />
                </div>
                <div class="col-md-12 mb-3 d-flex justify-content-between">
                  <div class="mb-3 ad-user">
                    <p-checkbox formControlName="approved" binary="true" inputId="ad_user" class="custom-checkbox me-3"
                      (change)="onAllRolesSame(true)"></p-checkbox>
                    <label for="ad_user"><b>Select only if you want the same user to be Initiator,
                        Recommender, and Approver for this step.</b></label>
                  </div>
                  <div class="footer-btn mt-6">
                    <button pButton label="Submit" type="submit" class="fetch-data-btn"
                      [disabled]="routeForm.invalid"></button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Make it table here -->
            <div class="mt-4 mb-4">
              <ng-container *ngIf="RouteUserList?.length > 0">
                <app-data-table [columns]="userCols" [data]="RouteUserList" [title]="'User Mapping'"
                  [isDeletable]="true" (deleteEventRow)="deleteUser($event)" [showAddButton]="false"
                  [showSearch]="false"></app-data-table>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>

<ng-container *ngIf="displayDialogN">
  <app-scheme-wise-route-popup [displayDialog]="displayDialogN" (closeDialog)="displayDialogN = false"
    (onSubmit)="onNeedformSubmit($event)"></app-scheme-wise-route-popup>
</ng-container>